'use strict';

angular.module('bringgApp.filters').filter('picker', function ($filter) {
	return function (value, filterName, arg0) {
		return $filter(filterName)(value, arg0);
	};
});
